import { API } from "@project/shared";

export const FetchJobDetails = async (id): Promise<any> => {
  return API.get(`/member/jobs/${id}`);
};
